import { IMAGES } from "../../lzapp_web_common_code/assets";

export const PRACTICE_TEST = [
  {
    id: 1,
    test_name: "Assessment Test",
    num_questions: 50,
    use_practice_test_id: true,
    practice_test_id: 1,
    icon: "memory",
    requires_subscription: false,
  },
  {
    id: 2,
    test_name: "Practice Test 1",
    num_questions: 100,
    use_practice_test_id: true,
    practice_test_id: 2,
    icon: "roman-numeral-1",
    requires_subscription: true,
  },
  {
    id: 3,
    test_name: "Practice Test 2",
    num_questions: 100,
    use_practice_test_id: true,
    practice_test_id: 3,
    icon: "roman-numeral-2",
    requires_subscription: true,
  },
  {
    id: 4,
    test_name: "Practice Test 3",
    num_questions: 100,
    use_practice_test_id: true,
    practice_test_id: 4,
    icon: "roman-numeral-3",
    requires_subscription: true,
  },
  {
    id: 5,
    test_name: "Practice Test 4",
    num_questions: 100,
    use_practice_test_id: true,
    practice_test_id: 5,
    icon: "roman-numeral-4",
    requires_subscription: true,
  },
];

export const APP_DOMAIN_LIST = [
  {
    id: 1,
    domain_name: "Network Fundamentals",
    chapters: [1],
    exam_weightage: 10,
    show_proficiency: true,
    icon: "network",
    requires_subscription: true,
    num_questions: 5,
    num_flashcards: 5,
  },
  {
    id: 2,
    domain_name: "Network Access",
    chapters: [2],
    exam_weightage: 10,
    show_proficiency: true,
    icon: "account-network",
    requires_subscription: true,
    num_questions: 5,
    num_flashcards: 5,
  },
  {
    id: 3,
    domain_name: "IP Connectivity",
    chapters: [3],
    exam_weightage: 10,
    show_proficiency: true,
    icon: "ip-network",
    requires_subscription: true,
    num_questions: 5,
    num_flashcards: 5,
  },
  {
    id: 4,
    domain_name: "IP Services",
    chapters: [3],
    exam_weightage: 10,
    show_proficiency: true,
    icon: "dns",
    requires_subscription: true,
    num_questions: 5,
    num_flashcards: 5,
  },
  {
    id: 5,
    domain_name: "Security Fundamentals",
    chapters: [3],
    exam_weightage: 10,
    show_proficiency: true,
    icon: "security-network",
    requires_subscription: true,
    num_questions: 5,
    num_flashcards: 5,
  },
  {
    id: 6,
    domain_name: "Automation and Programmability",
    chapters: [3],
    exam_weightage: 10,
    show_proficiency: true,
    icon: "code-braces-box",
    requires_subscription: true,
    num_questions: 5,
    num_flashcards: 5,
  },
];

/** FLASH CARD MENU */
export const GET_FLASH_CARD_MENU = () => {
  return [
    {
      title: "Bookmark",
      icon_bg: "#FFEFED",
      image: IMAGES?.ic_flash_bookmark,
      menu: null,
      key: "bookmark",
      requires_subscription: false,
    },
    {
      title: "Quick Set (10)",
      icon_bg: "#E6FBFF",
      key: "quick",
      image: IMAGES?.ic_flash_quick_set,
      menu: null,
      requires_subscription: false,
    },
    {
      title: "Exam Essentials",
      icon_bg: "#FFF5E6",
      image: IMAGES?.ic_flash_exam,
      menu: null,
      key: "exam",
      topic_ids: [200],
      requires_subscription: true,
    },
    {
      title: "All Flashcards",
      icon_bg: "#FFF5E6",
      key: "all_cards",
      topic_ids: [100],
      image: IMAGES?.ic_flash_topic,
      menu: null,
      requires_subscription: true,
    },
  ];
};

export const GET_STUDY_QUESTION_MENU = () => {
  return [
    {
      title: "Bookmark",
      icon_bg: "#FFEFED",
      key: "bookmark",
      image: IMAGES?.ic_flash_bookmark,
      menu: APP_DOMAIN_LIST
    },
    {
      title: "Quick Set (10)",
      icon_bg: "#E6FBFF",
      key: "quick",
      image: IMAGES?.ic_flash_quick_set,
      menu: null,
      requires_subscription: true,
    },
    {
      title: "By Topics (Free Plan)",
      icon_bg: "#F3FFD9",
      key: "by_topic_free_model",
      image: IMAGES?.ic_flash_topic,
      free_model: 1,
      menu: APP_DOMAIN_LIST,
    },
    {
      title: "By Topics (Premium Plan)",
      icon_bg: "#F3FFD9",
      key: "by_topic",
      image: IMAGES?.ic_flash_topic,
      menu: APP_DOMAIN_LIST,
    },
  ];
};

export const GET_ARTICLE_MENU = () => {
  return [
    {
      title: "Bookmark",
      icon_bg: "#FFEFED",
      key: "bookmark",
      image: IMAGES?.ic_flash_bookmark,
      menu: null,
      requires_subscription: false,
    },
    {
      title: "Quick Set (10)",
      icon_bg: "#E6FBFF",
      key: "quick",
      image: IMAGES?.ic_flash_quick_set,
      menu: null,
      requires_subscription: false,
    },
    {
      title: "By Topics",
      icon_bg: "#F3FFD9",
      key: "by_topic",
      image: IMAGES?.ic_flash_topic,
      menu: APP_DOMAIN_LIST,
    },
  ];
};

export const QUESTION_VERSION_OF_JSON = 3;
